import { tv, VariantProps } from "@/utils";

export const social = tv({
  slots: {
    base: ["flex flex-col md:flex-row md:items-center gap-5"],
    title: [],
    list: ["justify-center flex flex-wrap items-center gap-5"],
    item: [],
    link: ["hover:opacity-80", "transition-opacity"],
    icon: ["w-5 h-5"],
  },
  variants: {
    color: {
      light: {
        base: ["text-white"],
      },
      dark: {
        base: ["text-green-900"],
      },
    },
  },
  defaultVariants: {
    color: "light",
  },
});

export type SocialVariantProps = VariantProps<typeof social>;

export type SocialReturnVariantProps = ReturnType<typeof social>;
